__turbopack_context__.v({
  "palette": "site-palette-module__BYQb7q__palette",
});
